import { HEADER_CLIENT_RELEASE } from "@faire/web--source/common/consts/HEADER_CLIENT_RELEASE";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { headerInterceptorFactory } from "./headerInterceptor";
export var releaseVersionHeaderInterceptor = headerInterceptorFactory({
    header: HEADER_CLIENT_RELEASE,
    value: function() {
        return getGlobalProperty("releaseVersion");
    }
});
